// extracted by mini-css-extract-plugin
module.exports = {"container":"MobileNav_container__AjnbG","menuContainer":"MobileNav_menuContainer__1DHed","menu":"MobileNav_menu__15_JA","open":"MobileNav_open__kKi_B"};